import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();

  sendErrorMessage(message: string) {
    this.subject.next(message);
  }

  clearErrorMessage() {
    this.subject.next('');
  }

  getErrorMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
